import Breastfeeding from '../sections/breastfeeding/breastfeeding';

export default function BreastFeedingPage() {
  return (
    <div className="section-page">
      <Breastfeeding />
    </div>
  );
}
